import { ErrorObject, Nullable, TestStatus, WithErrors } from "../../types";
import {
    ActivityLevel,
    AdvancedPersonalData,
    AdvancedPersonalDataFromAPI,
    BasicPersonalData,
    BasicPersonalDataFromAPI,
    BasicPersonalDataWithErrorsFromAPI,
    Gender,
} from "./types";

export const convertBasicPersonalData = (
    dataFromAPI: Nullable<BasicPersonalDataFromAPI>
): Nullable<BasicPersonalData> => {
    return !dataFromAPI
        ? null
        : {
              age: dataFromAPI.person.age,
              bmi: dataFromAPI.person.bmi,
              fat: dataFromAPI.person.fat,
              firstName: dataFromAPI.person.first_name,
              lastName: dataFromAPI.person.last_name,
              height: dataFromAPI.person.height,
              identification: dataFromAPI.person.identification,
              weight: dataFromAPI.person.weight,
              status: dataFromAPI.test_status as TestStatus,
              testDate: dataFromAPI.test_date,
              testId: dataFromAPI.test_id,
              gender: dataFromAPI.person.gender as Gender,
          };
};

export const convertBasicPersonalDataSubmissionResponse = (
    data: Nullable<BasicPersonalDataWithErrorsFromAPI>
): Nullable<WithErrors<BasicPersonalData>> => {
    if (!data) return data;

    return {
        age: data.person.age,
        bmi: data.person.bmi,
        fat: data.person.fat,
        firstName: data.person.first_name,
        lastName: data.person.last_name,
        gender: data.person.gender as Gender,
        height: data.person.height,
        identification: data.person.identification,
        weight: data.person.weight,
        testDate:
            typeof data.test_date === "string"
                ? data.test_date?.replace(" 00:00:00", "")
                : data.test_date,
        testId: data.test_id,
    };
};

export const invertBasicPersonalData = (
    data: BasicPersonalData
): Omit<
    BasicPersonalDataFromAPI,
    "navbar_status" | "test_id" | "test_status"
> => {
    return {
        person: {
            age: data.age,
            bmi: data.bmi,
            fat: data.fat,
            first_name: data.firstName,
            last_name: data.lastName,
            height: data.height,
            identification: data.identification,
            weight: data.weight,
            gender: data.gender,
        },
        test_date: data.testDate,
    };
};

export const convertAdvancedPersonalData = (
    dataFromAPI: Nullable<AdvancedPersonalDataFromAPI>
): Nullable<WithErrors<AdvancedPersonalData>> => {
    return !dataFromAPI
        ? null
        : {
              active: dataFromAPI.active as ActivityLevel | ErrorObject,
              race: dataFromAPI.race as string | ErrorObject,
              smoker: dataFromAPI.smoker,
              all_race_types: dataFromAPI.all_race_types,
          };
};
